/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import routeChanged from 'route-changed';
import { slug as extSlug } from '../common';

export default function () {
	let whitelist;

	let prevRoute;

	function registerPageVisit(route) {
		try {
			// Get the settings and cache them in a variable
			if (!whitelist) {
				try {
					whitelist = JSON.parse(app.forum.attribute(`${extSlug}.pageVisitsWhitelist`));
					whitelist = whitelist.map((item) => {
						const { rule } = item;
						const pieces = rule.split('/');
						const options = pieces.pop();
						pieces.shift();
						return { regex: new RegExp(pieces.join('/'), options), ...item };
					});
				} catch (e) {
					whitelist = [];
				}
			}

			// Check if the current route is whitelisted and get the slug of that item
			const { slug, regex } = whitelist.find((item) => item.regex.test(route));
			if (!slug) {
				return;
			}

			// HARD CODED SPECIAL CASE FOR "discussion" ROUTE
			if ((slug === 'discussion' || /\\\/d\\\//.test(regex.toString())) && prevRoute) {
				// Check if the previous route also matches the regex
				const { slug: prevSlug } = whitelist.find((item) => item.regex.test(prevRoute));
				if (prevSlug === slug) {
					// Check if both routes match the same discussion
					let matches = prevRoute.match(regex);
					// Extract the id, it would be the second group in the matches
					const prevId = matches[2];
					matches = route.match(regex);
					const id = matches[2];
					if (prevId === id) {
						return;
					}
				}
			}

			app
				.request({
					method: 'POST',
					url: '/api/gamilytics/pageVisit',
					body: { route, slug },
					errorHandler: () => {},
				})
				.catch(() => {});

			// Save for next time
			prevRoute = route;
		} catch (e) {
			// console.error(e);
		}
		// We will not throw an error here, because this is a background task and we don't care if it fails.
	}

	// This is to monitor the initial page load.
	// We need to defer it to make sure that the page is fully loaded.
	setTimeout(() => {
		registerPageVisit(window.location.pathname);
	}, 0);

	// This is to monitor route changes (routes are changed by `m.route.set()`).
	routeChanged((route) => {
		registerPageVisit(route);
	});
}
